// src/components/forums/TopicSkeleton.tsx
import React from 'react';
import { cn } from '@/lib/utils';
import { useTheme } from '@/contexts/ThemeContext';

const TopicSkeleton: React.FC = () => {
  const { isDarkMode } = useTheme();

  return (
    <div
      className={cn(
        "w-full rounded-xl border overflow-hidden animate-pulse", // ← ensure full width
        isDarkMode ? "bg-dark-200 border-dark-300" : "bg-light-100 border-light-300"
      )}
    >
      {/* Header */}
      <div
        className={cn(
          "p-6 border-b",
          isDarkMode ? "border-dark-300" : "border-light-300"
        )}
      >
        <div className="flex items-center gap-4">
          <div className="w-10 h-10 rounded-full bg-dark-300"></div>
          <div className="flex-1 space-y-2">
            <div className="h-6 bg-dark-300 rounded w-3/4"></div>
            <div className="h-4 bg-dark-300 rounded w-1/2"></div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="p-6">
        <div className="space-y-4">
          <div className="h-4 bg-dark-300 rounded w-full"></div>
          <div className="h-4 bg-dark-300 rounded w-full"></div>
          <div className="h-4 bg-dark-300 rounded w-full"></div>
          <div className="h-4 bg-dark-300 rounded w-3/4"></div>
          <div className="h-4 bg-dark-300 rounded w-5/6"></div>
          <div className="h-4 bg-dark-300 rounded w-2/3"></div>
        </div>
      </div>
    </div>
  );
};

export default TopicSkeleton;
